import { showSelfLabel } from "utils/helper";
import { CommonText, RoundMiniImage } from "../../styledComponents/common";
import {
  AssigneesManageImgTextGrid,
  AssigneesManageRoundImage,
} from "../../styledComponents/createProject";
import FirstRoundLetter from "../ColorLetterRound/FirstRoundLetter";

const RoundImageNameComp = ({
  imageSize,
  imgSource,
  name,
  index,
  size,
  fontSize,
  fontWeight,
  fill,
  selectedMemberId,
  userId,
}) => {
  return (
    <AssigneesManageImgTextGrid>
      <AssigneesManageRoundImage imageSize={imageSize}>
        {imgSource !== null ? (
          <RoundMiniImage src={imgSource} alt={name} imageSize={imageSize} />
        ) : (
          <FirstRoundLetter
            text={name}
            backColor={index}
            size={imageSize}
            fontSize={size || "16px"}
          />
        )}
      </AssigneesManageRoundImage>

      <CommonText name={fill} fontSize={fontSize} fontWeight={fontWeight}>
        {selectedMemberId === userId ? name : showSelfLabel(userId, name)}
      </CommonText>
    </AssigneesManageImgTextGrid>
  );
};
export default RoundImageNameComp;
